var ARScope=new (function(){

    var local=[];

    this.set=function(name,val) {
        local[name]=val;
    };

    this.get=function(name) {
        return local[name];
    };

    return this;
});

function rrequire(name) {
    if(name.indexOf("text!")===0) {
        return window.templates[name.substr("text!".length)];
    }
    var e= ARScope.get(name);
    if(!e) {
        throw "Undefined packet " + name;
    }
    return e();
}

function rdefine(name,deps,cb) {
    var _cache=null;
    ARScope.set(name,function(){
        if(_cache) {
            return _cache;
        }
        var args=[];
        for(var i in deps) {
            args.push(rrequire(deps[i]));
        }
        _cache=cb.apply(window,args);
        return _cache;
    });
}

rdefine("backbone",[],function(){ return window.Backbone; });

